import { useToast } from 'altoneo-charting';
import { messageErreur } from '@/lib/api';

export interface Notifier {
  succes: (message: string) => void;
  erreur: (e: unknown, repli?: string) => void;
  info: (message: string) => void;
  avertissement: (message: string) => void;
}

/**
 * Les toasts d'altoneo-charting, typés et en français. La librairie n'a pas de
 * types : sans cette enveloppe, chaque écran appellerait un `any` et une faute
 * de frappe (`sucess`) ne se verrait qu'à l'exécution, au pire moment.
 */
export function useNotifier(): Notifier {
  const toast = useToast();
  return {
    succes: (m) => toast.success(m),
    erreur: (e, repli) => toast.error(messageErreur(e, repli), { duration: 6000 }),
    info: (m) => toast.info(m),
    avertissement: (m) => toast.warning(m, { duration: 6000 }),
  };
}
